import { render } from "./CampaignsManagementDetailsMessages.vue?vue&type=template&id=1ccaa324&scoped=true&ts=true"
import script from "./CampaignsManagementDetailsMessages.vue?vue&type=script&lang=ts"
export * from "./CampaignsManagementDetailsMessages.vue?vue&type=script&lang=ts"

import "./CampaignsManagementDetailsMessages.vue?vue&type=style&index=0&id=1ccaa324&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccaa324"]])

export default __exports__